export default {
  currentParishPosts: (state, getters, rootState) => {
    let posts = []
    if (rootState.ParishModule.current && state.posts[rootState.ParishModule.current.id]) {
      posts = Object.entries(state.posts[rootState.ParishModule.current.id])
        .sort((a, b) => new Date(b[1].published) - new Date(a[1].published))
        .map(item => ({ ...item[1], id: item[0] }))
    }

    return posts
  },
  currentParishPhotos: (state, getters, rootState) => {
    let photos = []
    if (rootState.ParishModule.current && state.photos[rootState.ParishModule.current.id]) {
      photos = Object.entries(state.photos[rootState.ParishModule.current.id])
        .sort((a, b) => new Date(b[1].uploaded) - new Date(a[1].uploaded))
        .map(item => ({ ...item[1], id: item[0] }))
    }

    return photos
  },
  currentParishFiles: (state, getters, rootState) => {
    let files = []
    if (rootState.ParishModule.current && state.files[rootState.ParishModule.current.id]) {
      files = state.files[rootState.ParishModule.current.id]
    }

    return files
  },
  currentParishCatalogs: (state, getters, rootState) => {
    let catalogs = {}
    if (rootState.ParishModule.current && state.catalogs[rootState.ParishModule.current.id]) {
      catalogs = state.catalogs[rootState.ParishModule.current.id]
    }

    return catalogs
  },
  currentParishVideos: (state, getters, rootState) => {
    let videos = []
    if (rootState.ParishModule.current && state.videos[rootState.ParishModule.current.id]) {
      videos = Object.entries(state.videos[rootState.ParishModule.current.id])
        .sort((a, b) => new Date(b[1].published) - new Date(a[1].published))
        .map(item => ({ ...item[1], id: item[0] }))
    }

    return videos
  },
  currentParishAboutPriest: (state, getters, rootState) => {
    if (!rootState.ParishModule.current) return ''
    return state.about[rootState.ParishModule.current.id]
  }
}
